/**
 * SignerContext — provides the active Signer to the component tree.
 */

import { createContext, useContext } from 'react';
import type { Signer } from '@/lib/signer';

const SignerContext = createContext<Signer | null>(null);

export const SignerProvider = SignerContext.Provider;

/** Get the active signer. Returns null if not logged in. */
export function useSigner(): Signer | null {
  return useContext(SignerContext);
}
